import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class EsetleirasEditDto extends IdentifiableDto {
	constructor() {
		super();
		this.nev = null;
		this.csorszam = null;
		this.feladatCsoport = null;
	}

	setup(props) {
		super.setup(props);
		this.nev = props.nev;
		this.csorszam = props.csorszam;
		this.feladatCsoport = props.feladatCsoport;
		return this;
	}
}

export default EsetleirasEditDto;
